function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M467.03 5.863l-.561-.241C459.242 2.399 457.097 0 386.638 0H93.395c-70.46 0-72.57 3.399-79.831 6.622l-.561.241C4.785 10.51 0 18.774 0 28s4.785 17.49 13.003 21.137l.56.241C20.792 52.601 22.937 56 93.396 56h293.21c70.492 0 72.604-2.399 79.831-5.622l.561-.241C475.215 46.49 480 37.246 480 28c.066-9.226-4.719-18.49-12.97-22.137z",
  fill: "currentColor"
});

var SvgBtnDecisionWide = function SvgBtnDecisionWide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 480 56",
    preserveAspectRatio: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtnDecisionWide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn_decision_wide.31ff8f54.svg";
export { ForwardRef as ReactComponent };